'use client';
import { ReactNode } from 'react';
import './DraggableImage.css';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';

interface DraggableImageProps {
	position: number;
	children: ReactNode;
}

const DraggableImage = ({ position, children }: DraggableImageProps) => {
	const { setNodeRef, transform, isDragging } = useSortable({
		id: position,
	});

	const style = {
		transform: CSS.Transform.toString(transform),
		opacity: isDragging ? 0.5 : 1,
	};

	return (
		<div className='draggable-image' ref={setNodeRef} style={style}>
			{children}
		</div>
	);
};

interface OverlayImageProps {
	url: string;
}

const OverlayImage = ({ url }: OverlayImageProps) => {
	return (
		<div className='overlay-image'>
			<img src={url} className='overlay-image__image' />
		</div>
	);
};

export { DraggableImage, OverlayImage };
